import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './ThemeContext';
import Landing from './pages/Landing';
import Meet from './pages/Meet';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/meet/:roomId" element={<Meet />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
